module.exports = __webpack_public_path__ + "assets/images/eccd6e454e5fbece82bdfcdf4b0fcf54-home-full-width-bg.png";